import { render } from "./SearchPatientInputAndResult.vue?vue&type=template&id=1a508016&scoped=true"
import script from "./SearchPatientInputAndResult.vue?vue&type=script&lang=js"
export * from "./SearchPatientInputAndResult.vue?vue&type=script&lang=js"

import "./SearchPatientInputAndResult.vue?vue&type=style&index=0&id=1a508016&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a508016"]])

export default __exports__